import BreadCrumb from "../../../CommonComponents/BreadCrumb.tsx";
import React from "react";
import BannerComponent from "../BannerComponent.tsx";
import backgroundImg from "../../../../assets/images/aptech-training-solutions-bg.png";
import logo from "../../../../assets/images/AptechTrainingEBG.png";
import SectionComponent from "../SectionComponent.tsx";
import styles from "./AptechTrainingSolutions.module.scss";

const AptechTrainingSolution: React.FC = () => {
  const breadcrumb = [
    { title: "Our Businesses", link: "/our-businesses" },
    {
      title: "Institutional Business",
      link: "/our-businesses/institutional-business/",
    },
    { title: "Aptechn Training Solutions", link: "" },
  ];
  return (
    <>
      <BreadCrumb menu={breadcrumb} />
      <div className="container mt-5 mb-5 d-flex flex-column gap-5">
        <BannerComponent
          bg={backgroundImg}
          title1="Aptech Training Solutions"
          title2="Building a Skilled, Future-Ready India"
        />
        <div className="d-flex flex-column flex-md-row gap-4 align-items-start">
          <div className="d-none d-md-block">
            <img src={logo} alt="course logo" />
          </div>
          <div className="d-flex flex-column" style={{ gap: 25 }}>
            <p>
              With a robust network of over <strong>740+ centers</strong> and
              over <strong>7.5 million</strong> learners trained,{" "}
              <strong>Aptech</strong> is a trusted partner for public
              institutions, educational bodies, and government agencies striving
              to build a skilled, future-ready workforce.
            </p>
            <p>
              Aligned with the National Education Policy (NEP) 2020, Aptech
              Training Solutions delivers end-to-end skilling solutions—from
              school-level foundation building and dropout reintegration to
              graduate upskilling and large-scale government training programs.
              Our offerings bridge academic learning with real-world job skills
              to ensure smooth mobility between education and employability.
            </p>
            <p>
              Our portfolio includes training in emerging technologies,
              leadership, communication, finance, and sectoral areas like media,
              wellness, hospitality, and healthcare—designed with adaptive
              learning, psychometric tools, and modular, role-based curricula.
            </p>
            <p>
              Aptech supports key government initiatives such as{" "}
              <strong> PMKVY 4.0, DDUGKY, Green Jobs, and RPL-BOCW,</strong> and
              is empanelled with{" "}
              <strong> NICSI, SWAYAM Plus, NFDC, ASAP Kerala,</strong> and major
              Sector Skill Councils like{" "}
              <strong>CSDCI, MESC, TSSC, and </strong>
              <strong>B&WSSC.</strong>
            </p>
          </div>
        </div>

        <div>
          <div className="d-flex flex-column align-items-center">
            <p className="text-center heading3 mb-0">Our Esteemed Clients</p>
            <p className="para">A testament to our national impact.</p>
          </div>

          <div className="d-flex flex-row justify-content-center">
            <div className={styles.scrollContainer}>
              <div className={styles.scrollDiv}>
                {[
                  "Rajya Sabha Secretariat",
                  "DMRC",
                  "NICSI",
                  "NALCO",
                  "LIC",
                  "IOCL",
                ]
                  .concat([
                    "Rajya Sabha Secretariat",
                    "DMRC",
                    "NICSI",
                    "NALCO",
                    "LIC",
                    "IOCL",
                  ])
                  .map((item, index) => (
                    <div
                      key={index}
                      className={`${styles.scrollItem} cardHeading`}
                    >
                      {item}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>

        <SectionComponent
          desc="For any leads, queries, or feedback please contact"
          title="<p>Aptech Training Solutions - <strong> Learn. Evolve. Succeed. </strong> </p>"
        />
      </div>
    </>
  );
};
export default AptechTrainingSolution;
